import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { PrivatePhysicalContactDetails } from 'src/Components/Contacts/PrivatePhysicalContactDetails';
import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';

type ContactParams = {
  contactId: string;
};

const ViewContactDrawer = () => {
  const { t } = useTranslation();
  const { contactId } = useParams<ContactParams>();

  if (!contactId) {
    return <Navigate to="/contacts" replace />;
  }

  return (
    <AnimatedRoutedDrawer title={t('contactDrawer.title', 'Fiche contact')}>
      {({ onClose }) => <PrivatePhysicalContactDetails contactId={contactId} onClose={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default ViewContactDrawer;
